'use client'

import { useFeedSorting } from '@repo/web-ui/ask-cf/contexts/feed-sorting-context'
import { useIsLoggedInQuery } from 'auth/hooks'

import { tw } from 'utils/classnames'

export function FeedTabs() {
  const { activeSortOption, setActiveSortOption } = useFeedSorting()
  const { data: isLoggedIn } = useIsLoggedInQuery()

  if (!isLoggedIn) {
    return null
  }

  return (
    <>
      <div className=" w-full h-14 flex flex-row gap-2 lg:max-w-[756px] mx-auto border-[#1313151F] border-b mb-4">
        <button
          className={tw(
            'flex-1 text-14 font-semibold rounded-t-2 max-w-[50%] hover:bg-cf-grey-25 border-t border-l border-r border-[#1313151F] bg-cf-white relative',
            activeSortOption === 'discovery-feed' ? ' text-cf-purple-900' : 'text-cf-grey-800 ',
          )}
          onClick={() => setActiveSortOption('discovery-feed')}
        >
          Discovery Feed
          {activeSortOption === 'discovery-feed' ? (
            <div className="rounded-t-2 bg-cf-purple-900 absolute bottom-0 left-0 right-0 h-1" />
          ) : null}
        </button>
        <button
          className={tw(
            'border-t border-l border-r flex-1 text-14 max-w-[50%] hover:bg-cf-grey-25 font-semibold rounded-t-2 border-[#1313151F] bg-cf-white relative',
            activeSortOption === 'your-feed' ? ' text-cf-purple-900' : 'text-cf-grey-800',
          )}
          onClick={() => setActiveSortOption('your-feed')}
        >
          Your Feed
          {activeSortOption === 'your-feed' ? (
            <div className="rounded-t-2 bg-cf-purple-900 absolute bottom-0 left-0 right-0 h-1" />
          ) : null}
        </button>
      </div>
    </>
  )
}
